import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { SubmissionError, reset } from 'redux-form';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import actions from '../../../actions';
import ProviderLoginForm from '../../components/ProviderLoginForm';
import serverError from '../../../common/serverMessages';
import * as Constant from '../../../constants/actionTypes';
import { firstLowerLetter, IconSelector, labelName } from '../../UtilsWeb';
import styles from './styles';
import AuthConfig from '../../../AuthConfig';
import Loading from '../../components/Loading';

class ProviderLoginPage extends PureComponent {
  static propTypes = {
    actions: PropTypes.object.isRequired,
    providerLogin: PropTypes.object.isRequired,
    locale: PropTypes.string.isRequired,
    history: PropTypes.object.isRequired,
    classes: PropTypes.object.isRequired,
    changeLocale: PropTypes.func.isRequired,
    getSupportedLanguages: PropTypes.func.isRequired,
  };

  state = {
    value: 0,
    isLoading: false,
  };

  componentDidMount = () => {
    const locale = sessionStorage.getItem('locale');
    const { changeLocale, getSupportedLanguages } = this.props;
    getSupportedLanguages();
    if (locale) {
      changeLocale(locale);
    } else {
      sessionStorage.setItem('locale', Constant.LABEL_EN);
      changeLocale(Constant.LABEL_EN);
    }
  };

  loginForm = formData => {
    const { onLine } = navigator;
    const { locale } = this.props;
    const formData1 = { ...formData, LanguageCode: locale.toUpperCase() };
    if (onLine) {
      const { actions: actionCall } = this.props;
      const { value } = this.state;
      if (!value) {
        this.setState({ isLoading: true });
        return actionCall
          .providerLogin(formData)
          .then(() => {
            const {
              providerLogin: { data, error },
            } = this.props;
            if (error) {
              this.setState({ isLoading: false });
              throw new SubmissionError({
                _error: serverError(error.ErrorCode),
              });
            } else {
              const { history } = this.props;
              this.setState({ isLoading: false });
              history.push({
                pathname: `${Constant.SLASH}${firstLowerLetter(Constant.PROVIDER_CARD_LINK)}`,
                state: {
                  data,
                },
              });
            }
          })
          .catch(() => {
            const {
              providerLogin: { error },
            } = this.props;
            this.setState({ isLoading: false });
            if (error) {
              throw new SubmissionError({
                _error: serverError(error.ErrorCode),
              });
            }
          });
      }
      this.setState({ isLoading: true });
      return actionCall
        .providerLoginHealthSummary(formData1)
        .then(() => {
          const {
            providerLogin: { data, error },
          } = this.props;
          if (error) {
            this.setState({ isLoading: false });
            const MDPErrorCode = error.ErrorCode;
            switch (MDPErrorCode) {
              case 'MDP301':
                throw new SubmissionError({
                  _error: serverError(MDPErrorCode),
                });
              case 'MDP303':
                throw new SubmissionError({
                  _error: serverError(MDPErrorCode),
                });
              case 'MDP304':
                throw new SubmissionError({
                  _error: serverError(MDPErrorCode),
                });
              case 'MDP403':
                throw new SubmissionError({
                  _error: serverError(MDPErrorCode),
                });
              case 'MDP404':
                throw new SubmissionError({
                  _error: serverError(MDPErrorCode),
                });
              case 'MDP405':
                throw new SubmissionError({
                  _error: serverError(MDPErrorCode),
                });
              case 'MDP457':
                throw new SubmissionError({
                  _error: serverError(MDPErrorCode),
                });
              case 'MDP458':
                throw new SubmissionError({
                  _error: serverError(MDPErrorCode),
                });
              case 'MDP459':
                throw new SubmissionError({
                  _error: serverError(MDPErrorCode),
                });
              default:
                throw new SubmissionError({
                  _error: serverError(MDPErrorCode),
                });
            }
          } else {
            const { history } = this.props;
            this.setState({ isLoading: false });
            history.push({
              pathname: `${Constant.SLASH}${firstLowerLetter(Constant.MY_HEALTH_SUMMARY_LINK)}`,
              state: {
                data,
              },
            });
          }
        })
        .catch(() => {
          const {
            providerLogin: { error },
          } = this.props;
          if (error) {
            this.setState({ isLoading: false });
            throw new SubmissionError({
              _error: serverError(error.ErrorCode),
            });
          }
        });
    }
    throw new SubmissionError({
      _error: Constant.LABEL_NO_INTERNET,
    });
  };

  handleChange = (event, value) => {
    this.setState({ value });
  };

  tabView = tabs => {
    const { value } = this.state;
    const { classes } = this.props;
    return (
      <Tabs
        value={value}
        onChange={this.handleChange}
        classes={{ root: classes.tabsRoot, indicator: classes.tabsIndicator }}
      >
        {tabs.map(tabValue => {
          return (
            <Tab
              key={tabValue.title}
              value={tabValue.value}
              disableRipple
              icon={IconSelector(tabValue.Icon, classes.IconStyle)}
              classes={{ root: classes.tabRoot, selected: classes.tabSelected }}
              label={labelName(tabValue.title)}
              style={{ minWidth: `${100 / tabs.length}%` }}
            />
          );
        })}
      </Tabs>
    );
  };

  tabDetailView = (value, tabs) => {
    const { locale } = this.props;
    const selectedTab = tabs.filter(header => header.value === value);
    return (
      <div style={{ padding: 20 }}>
        <h2 className="pageHeader">{labelName(selectedTab[0].Header)}</h2>
        <ProviderLoginForm locale={locale} onSubmit={this.loginForm} />
      </div>
    );
  };

  render() {
    const { value, isLoading } = this.state;
    const tabs = AuthConfig.filter(x => x.visible);
    return (
      <div className="bodyContainerWrapper" role="main">
        {isLoading && <Loading />}
        <Paper className="pageContentWrapper" style={{ padding: 0 }}>
          {tabs.length > 1 && this.tabView(tabs)}
          {this.tabDetailView(value, tabs)}
        </Paper>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  providerLogin: state.providerLogin,
  locale: state.locale.locale,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(actions, dispatch),
  resetForm: () => {
    dispatch(reset(Constant.PROVIDER_SIGN_IN));
  },
  changeLocale: locale => {
    dispatch(actions.changeLocale(locale));
  },
  getSupportedLanguages: () => {
    dispatch(actions.getSupportedLanguages());
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(styles)(ProviderLoginPage));
